// Debug logger utility for controlled logging
// Usage: import debugLogger from 'src/platform/utils/debugLogger';

export enum LogLevel {
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

const _LOG_LEVELS: LogLevel[] = [
  LogLevel.DEBUG,
  LogLevel.INFO,
  LogLevel.WARN,
  LogLevel.ERROR,
];

// Read from environment variable
const isDebugEnabled =
  import.meta.env.VITE_DEBUG_LOGGER === "true" ||
  (import.meta.env.DEV && import.meta.env.VITE_DEBUG_LOGGER !== "false");

function formatMessage(level: LogLevel, ..._args: unknown[]): string {
  const timestamp = new Date().toISOString();
  return `[${timestamp}] [${level.toUpperCase()}]`;
}

const debugLogger = {
  debug: (...args: unknown[]) => {
    if (isDebugEnabled) {
      // eslint-disable-next-line no-console
      console.debug(formatMessage(LogLevel.DEBUG), ...args);
    }
  },
  info: (...args: unknown[]) => {
    if (isDebugEnabled) {
      // eslint-disable-next-line no-console
      console.info(formatMessage(LogLevel.INFO), ...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isDebugEnabled) {
      // eslint-disable-next-line no-console
      console.warn(formatMessage(LogLevel.WARN), ...args);
    }
  },
  error: (...args: unknown[]) => {
    // Always log errors in development, only if enabled in production
    if (isDebugEnabled || import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error(formatMessage(LogLevel.ERROR), ...args);
    }
  },
};

export default debugLogger;
